import base from "@/store/utils/api-route/base";

const api = {
    getListPaket: `${base.masterData}whatsapp/list_paket`,
    getListBank: `${base.masterData}whatsapp/list_bank_pembayaran`,
    getListPerangkat: `${base.masterData}whatsapp/list_perangkat_wa`,
    getVoucher: `${base.masterData}whatsapp/list_voucher_wa`,
    getDetailTagihan: `${base.masterData}whatsapp/detail_tagihan_wa`,
    getDetailDevice: `${base.masterData}whatsapp/detail_device_wa`,
    getDetailTinyDevice: `${base.masterData}whatsapp/detail_device_wa_tiny`,
    registed: `${base.masterData}whatsapp/registrasi_device`,
    updateDeviceDetail: `${base.masterData}whatsapp/update_device_wa`,
    removeDevice: `${base.masterData}whatsapp/remove_wa_device`,
    updatePaketDevice: `${base.masterData}whatsapp/update_paket_device_wa`,
    recreateWorker: `${base.masterData}whatsapp/recreate_wa_worker`,
    createWorker: `${base.masterData}whatsapp/create_wa_worker`,
    removeWorker: `${base.masterData}whatsapp/remove_wa_worker`,
    getRiwayatPaket: `${base.masterData}whatsapp/list_riwayat_pembelian_paket`,
    getListCustomer: `${base.masterData}whatsapp/list_message_customer`,
    getHistoryPesan: `${base.masterData}whatsapp/list_history_message`,
    getDetailHistoryPesan: `${base.masterData}whatsapp/detail_history_message`,
    sendTestMessage: `${base.masterData}whatsapp/send_test_wa_message`,
    resendMessage: `${base.masterData}whatsapp/resend_failed_message`,
    resendAllMessage: `${base.masterData}whatsapp/resend_failed_message_per_device`,
    setIsconnectDevice: `${base.masterData}whatsapp/update_status_terhubung`,
    getListDeviceTiny: `${base.masterData}whatsapp/list_perangkat_wa_tiny`,
    getListOutlet: `${base.masterData}whatsapp/list_outlet_linked`,
    getListOutletFree: `${base.masterData}whatsapp/list_outlet_unlinked`,
    integrasiOutlet: `${base.masterData}whatsapp/integrasi_outlet_wa`,
    unlinkOutlet: `${base.masterData}whatsapp/remove_integrasi_outlet`,
    getSettingWa: `${base.masterData}whatsapp/detail_setting_outlet`,
    changeDevice: `${base.masterData}whatsapp/change_device`,
    updateTemplate: `${base.masterData}whatsapp/change_template_wa`,
    changeSettingTemplate: `${base.masterData}whatsapp/change_status_template_wa`,
    getDetailTemplatePesan: `${base.masterData}whatsapp/detail_template_pesan`,
    resetTemplatePesan: `${base.masterData}whatsapp/reset_template_pesan`,
	getHistoryPesanV2: `${base.masterData}whatsapp/list_history_message_v2`,
	countSummary: `${base.masterData}whatsapp/count_summary`,
};

export default api;
